import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight, Facebook } from 'lucide-react';

const FacebookFeedSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div id="facebook-feed">
      <div className="mb-7">
        <p className="eyebrow">From our community</p>
        <h2 className="section-title">{t('facebook.title', 'Latest Updates')}</h2>
        <p className="mt-3 text-sm leading-6 text-[#667085]">
          {t('facebook.description', 'Stay connected with our latest news, events, and community updates on Facebook.')}
        </p>
      </div>

      <div className="surface overflow-hidden">
        <div className="flex items-center justify-between border-b border-[#e3e7ec] bg-white px-4 py-3">
          <div className="flex items-center gap-2 text-sm font-bold text-[#2457a7]">
            <Facebook className="h-4 w-4" />
            JAJ Florida
          </div>
          <a href="https://www.facebook.com/jaj.florida" target="_blank" rel="noopener noreferrer" className="text-[#667085] transition hover:text-[#2457a7]" aria-label="Open JAJ Facebook page">
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
        <div className="h-[640px] overflow-hidden bg-white">
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fjaj.florida&tabs=timeline&width=500&height=640&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false&lazy=true&appId"
            width="500"
            height="640"
            style={{ border: 'none', overflow: 'hidden' }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            title="JAJ Facebook updates"
            className="h-full w-full"
            loading="lazy"
          />
        </div>
      </div>

      <a href="https://www.facebook.com/jaj.florida" target="_blank" rel="noopener noreferrer" className="btn-secondary mt-4 w-full">
        <Facebook className="h-4 w-4" />
        {t('facebook.followButton', 'Follow us on Facebook')}
      </a>
    </div>
  );
};

export default FacebookFeedSection;
